import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full" }
const _hoisted_2 = { class: "flex flex-col items-center mt-4" }
const _hoisted_3 = { class: "reader-container" }
const _hoisted_4 = {
  ref: "videoRef",
  class: "reader-video",
  autoplay: "",
  muted: "",
  playsinline: ""
}
const _hoisted_5 = {
  key: 0,
  class: "scanner-overlay"
}
const _hoisted_6 = {
  key: 0,
  class: "error-message mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("video", _hoisted_4, null, 512),
        _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"scan-guide\" aria-hidden=\"true\" data-v-6bdc08e9><div class=\"scan-window\" data-v-6bdc08e9><span class=\"corner corner-tl\" data-v-6bdc08e9></span><span class=\"corner corner-tr\" data-v-6bdc08e9></span><span class=\"corner corner-bl\" data-v-6bdc08e9></span><span class=\"corner corner-br\" data-v-6bdc08e9></span></div></div>", 1)),
        (_ctx.isWasmLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "spinner" }, null, -1),
              _createElementVNode("div", { class: "overlay-text" }, "バーコードエンジンを初期化中...", -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stopScanning && _ctx.stopScanning(...args))),
        class: "stop-button mt-2"
      }, "スキャンを停止")
    ], 512), [
      [_vShow, _ctx.isScanning]
    ]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true)
  ]))
}